$(function () {
	$(".fantasy-featured-collection__slider").slick({
		dots: false,
		arrows: false,
		infinite: true,
		swipeToSlide: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 481,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	})
	$(".fantasy-featured-collection__arrows .arrow-prev").click(function () {
		$(".fantasy-featured-collection__slider").slick("slickPrev")
	})
	$(".fantasy-featured-collection__arrows .arrow-next").click(function () {
		$(".fantasy-featured-collection__slider").slick("slickNext")
	})
	$(".fantasy-featured-collection__slider").slick("slickAdd")

	if ($(window).width() < 768) {
		$(".fantasy-featured-collection__item .item-inner").click(function () {
			if ($(this).hasClass("active")) {
			} else {
				$(".fantasy-featured-collection__item .item-inner").removeClass("active")
				$(this).addClass("active")
			}
		})
		$(".fantasy-featured-collection__item .item-inner .image-wrap").click(function () {
			if ($(this).parent().hasClass("active")) {
				var url = $(this).parent().data("url")
				window.location.href = url
			}
		})
	}

	$(".fantasy-testimonials__media-slider").slick({
		dots: false,
		arrows: false,
		infinite: true,
		swipeToSlide: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 481,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	})

	$(".fantasy-tolstoy__carousel").slick({
		dots: false,
		arrows: false,
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	})
	$(".fantasy-tolstoy__arrows .arrow-prev").click(function () {
		$(".fantasy-tolstoy__carousel").slick("slickPrev")
	})
	$(".fantasy-tolstoy__arrows .arrow-next").click(function () {
		$(".fantasy-tolstoy__carousel").slick("slickNext")
	})
	$(".fantasy-gallery__marquee").simplyScroll({ pauseOnHover: true })

	$(".fantasy-recipes__slider").slick({
		dots: false,
		arrows: true,
		infinite: true,
		swipeToSlide: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow:
			'<div class="arrow-left"><svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26 15.7735C26.5523 15.7735 27 16.2212 27 16.7735C27 17.3258 26.5523 17.7735 26 17.7735V15.7735ZM6.5 17.6395C5.83333 17.2546 5.83333 16.2924 6.5 15.9075L13.5 11.866C14.1667 11.4811 15 11.9623 15 12.7321V20.815C15 21.5848 14.1667 22.0659 13.5 21.681L6.5 17.6395ZM26 17.7735H15C14.4477 17.7735 14 17.3258 14 16.7735C14 16.2212 14.4477 15.7735 15 15.7735H26V17.7735Z" fill="white"/></svg></div>',
		nextArrow:
			'<div class="arrow-right"><svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 15.7735C6.44771 15.7735 6 16.2212 6 16.7735C6 17.3258 6.44771 17.7735 7 17.7735V15.7735ZM26.5 17.6395C27.1667 17.2546 27.1667 16.2924 26.5 15.9075L19.5 11.866C18.8333 11.4811 18 11.9623 18 12.7321V20.815C18 21.5848 18.8333 22.0659 19.5 21.681L26.5 17.6395ZM7 17.7735H18C18.5523 17.7735 19 17.3258 19 16.7735C19 16.2212 18.5523 15.7735 18 15.7735H7V17.7735Z" fill="white"/></svg></div>',
	})
	$(".fantasy-recipes__slider").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
		$(".fantasy-recipes__image").hide()
		var i = nextSlide + 1
		var category = $(".fantasy-recipes__tab .tablinks.active").data("tab")
		var category = $(".fantasy-recipes__tab .tablinks.active").data("tab")
		$("#" + category + "__image-" + i).show()
	})

	$(".pwi__slider-mobile").slick({
		dots: false,
		arrows: false,
		infinite: true,
		variableWidth: true,
		speed: 0,
		slidesToShow: 1,
		slidesToScroll: 1,
		cssEase: "linear",
	})
	$(".pwi__slider").slick({
		dots: false,
		arrows: false,
		infinite: true,
		variableWidth: true,
		speed: 0,
		slidesToShow: 4,
		slidesToScroll: 4,
		cssEase: "linear",
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					infinite: false,
					variableWidth: false,
					speed: 300,
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
			{
				breakpoint: 768,
				settings: {
					infinite: false,
					variableWidth: false,
					speed: 300,
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
		],
	})
	$(".pwi__influencer-arrow.arrow-left").click(function () {
		$(".pwi__slider").slick("slickPrev")
	})
	$(".pwi__influencer-arrow.arrow-right").click(function () {
		$(".pwi__slider").slick("slickNext")
	})
	$(".pwi__slider").slick("slickAdd")
	if ($(window).width() < 1025) {
		var i = 0
		$(".pwi__slider").on("swipe", function (event, slick, direction) {
			var max = $(".pwi__slider").data("max") - 1
			if (direction == "left") {
				if (i < max) {
					i = i + 1
				}
			} else {
				if (i > 0) {
					i = i - 1
				}
			}
			$(".pwi__influencer-item").hide()
			$(".pwi__influencer-item[data-index=" + i + "]").show()
		})
		$(".pwi__influencer-arrow.arrow-left").click(function () {
			if (i > 0) {
				i = i - 1
			}
			$(".pwi__influencer-item").hide()
			$(".pwi__influencer-item[data-index=" + i + "]").show()
		})
		$(".pwi__influencer-arrow.arrow-right").click(function () {
			var max = $(".pwi__slider").data("max") - 1
			if (i < max) {
				i = i + 1
			}
			$(".pwi__influencer-item").hide()
			$(".pwi__influencer-item[data-index=" + i + "]").show()
		})
	}
	if ($(window).width() > 1024 && $(window).width() <= 1440) {
		var item = $(".pwi__slider .product-grid-item").width()
		if (item < 275) {
			var w = item * 3 + 195
			$(".pwi__influencer").css("width", $(window).width() - w)
		} else {
			$(".pwi__influencer").css("width", $(window).width() - 1020)
		}
	} else if ($(window).width() > 1440) {
		var item = $(".pwi__slider .product-grid-item").width()
		$(".pwi__influencer").css("width", item)
	} else {
		$(".pwi__influencer").css("width", "auto")
	}

	$(".featured-blog__slider").slick({
		dots: true,
		arrows: false,
		infinite: false,
		variableWidth: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	})
	$(".featured-blog__arrows svg").click(function () {
		var arrow = $(this).data("arrow")
		if (arrow == "left") {
			$(".featured-blog__slider").slick("slickPrev")
		} else {
			$(".featured-blog__slider").slick("slickNext")
		}
	})

	$(".featured-collections__slider").slick({
		dots: true,
		arrows: false,
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 4,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				},
			},
			{
				breakpoint: 768,
				settings: {
					dots: false,
					infinite: true,
					centerMode: true,
					centerPadding: "50px",
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
			{
				breakpoint: 480,
				settings: {
					dots: false,
					infinite: true,
					centerMode: true,
					centerPadding: "50px",
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	})
	$(".featured-collections__tabs li.tabs__link").click(function () {
		$(".featured-collections__tabs li.tabs__link").removeClass("current")
		$(this).addClass("current")
		$(".featured-collections__tab").removeClass("current")
		var i = $(this).data("tabs-link")
		$(".featured-collections__tab[data-tab=" + i + "]").addClass("current")
		$(".featured-collections__tab[data-tab=" + i + "] .featured-collections__slider").slick("slickAdd")
	})
	$(".featured-collections__arrows svg").click(function () {
		var arrow = $(this).data("arrow")
		if (arrow == "left") {
			$(".featured-collections__slider").slick("slickPrev")
		} else {
			$(".featured-collections__slider").slick("slickNext")
		}
	})
	setTimeout(function () {
		$(".featured-collections__content").css("opacity", "1")
	}, 1000)

	$(".testimonials__slider1").slick({
		dots: false,
		arrows: false,
		infinite: true,
		centerMode: true,
		centerPadding: "100px",
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 768,
				settings: {
					centerPadding: "75px",
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					centerPadding: "75px",
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	})

	$(".testimonials2__slider").slick({
		dots: false,
		arrows: true,
		infinite: true,
		swipeToSlide: true,
		centerMode: true,
		centerPadding: "200px",
		slidesToShow: 4,
		slidesToScroll: 1,
		prevArrow:
			'<div class="arrow-left"><svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="44" height="44" rx="22" transform="matrix(-1 0 0 1 44 0)" fill="white"/><rect x="-0.5" y="0.5" width="43" height="43" rx="21.5" transform="matrix(-1 0 0 1 43 0)" stroke="#002156" stroke-opacity="0.15"/><g clip-path="url(#clip0_6038_383)"><path d="M17.7929 22.7071C17.4024 22.3166 17.4024 21.6834 17.7929 21.2929L24.1569 14.9289C24.5474 14.5384 25.1805 14.5384 25.5711 14.9289C25.9616 15.3195 25.9616 15.9526 25.5711 16.3431L19.9142 22L25.5711 27.6569C25.9616 28.0474 25.9616 28.6805 25.5711 29.0711C25.1805 29.4616 24.5474 29.4616 24.1569 29.0711L17.7929 22.7071ZM20.5 23H18.5V21H20.5V23Z" fill="#002156"/></g><defs><clipPath id="clip0_6038_383"><rect width="9" height="16" fill="white" transform="matrix(-1 0 0 1 26.5 14)"/></clipPath></defs></svg></div>',
		nextArrow:
			'<div class="arrow-right"><svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="44" height="44" rx="22" fill="white"/><rect x="0.5" y="0.5" width="43" height="43" rx="21.5" stroke="#002156" stroke-opacity="0.15"/><g clip-path="url(#clip0_6038_380)"><path d="M26.2071 22.7071C26.5976 22.3166 26.5976 21.6834 26.2071 21.2929L19.8431 14.9289C19.4526 14.5384 18.8195 14.5384 18.4289 14.9289C18.0384 15.3195 18.0384 15.9526 18.4289 16.3431L24.0858 22L18.4289 27.6569C18.0384 28.0474 18.0384 28.6805 18.4289 29.0711C18.8195 29.4616 19.4526 29.4616 19.8431 29.0711L26.2071 22.7071ZM23.5 23H25.5V21H23.5V23Z" fill="#002156"/></g><defs><clipPath id="clip0_6038_380"><rect width="9" height="16" fill="white" transform="translate(17.5 14)"/></clipPath></defs></svg></div>',
		responsive: [
			{
				breakpoint: 1921,
				settings: {
					centerPadding: "100px",
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 1025,
				settings: {
					centerPadding: "100px",
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 992,
				settings: {
					centerPadding: "75px",
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					centerPadding: "30px",
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	})

	$(".testimonials3__slider").slick({
		dots: true,
		arrows: false,
		infinite: true,
		swipeToSlide: true,
		slidesToShow: 1,
		slidesToScroll: 1,
	})

	$(".featured-collections3__slider").slick({
		dots: false,
		arrows: true,
		infinite: true,
		swipeToSlide: true,
		centerMode: true,
		centerPadding: "250px",
		slidesToShow: 4,
		slidesToScroll: 1,
		prevArrow:
			'<div class="arrow-left"><svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="44" height="44" rx="22" transform="matrix(-1 0 0 1 44 0)" fill="white"/><rect x="-0.5" y="0.5" width="43" height="43" rx="21.5" transform="matrix(-1 0 0 1 43 0)" stroke="#002156" stroke-opacity="0.15"/><g clip-path="url(#clip0_6038_383)"><path d="M17.7929 22.7071C17.4024 22.3166 17.4024 21.6834 17.7929 21.2929L24.1569 14.9289C24.5474 14.5384 25.1805 14.5384 25.5711 14.9289C25.9616 15.3195 25.9616 15.9526 25.5711 16.3431L19.9142 22L25.5711 27.6569C25.9616 28.0474 25.9616 28.6805 25.5711 29.0711C25.1805 29.4616 24.5474 29.4616 24.1569 29.0711L17.7929 22.7071ZM20.5 23H18.5V21H20.5V23Z" fill="#002156"/></g><defs><clipPath id="clip0_6038_383"><rect width="9" height="16" fill="white" transform="matrix(-1 0 0 1 26.5 14)"/></clipPath></defs></svg></div>',
		nextArrow:
			'<div class="arrow-right"><svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="44" height="44" rx="22" fill="white"/><rect x="0.5" y="0.5" width="43" height="43" rx="21.5" stroke="#002156" stroke-opacity="0.15"/><g clip-path="url(#clip0_6038_380)"><path d="M26.2071 22.7071C26.5976 22.3166 26.5976 21.6834 26.2071 21.2929L19.8431 14.9289C19.4526 14.5384 18.8195 14.5384 18.4289 14.9289C18.0384 15.3195 18.0384 15.9526 18.4289 16.3431L24.0858 22L18.4289 27.6569C18.0384 28.0474 18.0384 28.6805 18.4289 29.0711C18.8195 29.4616 19.4526 29.4616 19.8431 29.0711L26.2071 22.7071ZM23.5 23H25.5V21H23.5V23Z" fill="#002156"/></g><defs><clipPath id="clip0_6038_380"><rect width="9" height="16" fill="white" transform="translate(17.5 14)"/></clipPath></defs></svg></div>',
		responsive: [
			{
				breakpoint: 1921,
				settings: {
					centerPadding: "250px",
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 1025,
				settings: {
					centerPadding: "100px",
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 992,
				settings: {
					centerPadding: "100px",
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					centerPadding: "30px",
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	})
	$(".featured-collections3__icons li").click(function () {
		$(".featured-collections3__icons li").removeClass("active")
		$(this).addClass("active")
		var c = $(this).data("collection")
		$(".featured-collections3__slider").hide()
		$("#" + c + "__slider").show()
		$("#" + c + "__slider").slick("slickAdd")
	})

	$(".tcwi2__columns").slick({
		dots: true,
		arrows: false,
		infinite: true,
		swipeToSlide: true,
		mobileFirst: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 767,
				settings: "unslick",
			},
		],
	})

	$(".products-grid__items").slick({
		dots: true,
		arrows: false,
		infinite: true,
		swipeToSlide: true,
		mobileFirst: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 767,
				settings: "unslick",
			},
		],
	})

	$(".recipes__slider").slick({
		dots: false,
		arrows: false,
		infinite: true,
		fade: true,
		adaptiveHeight: true,
		slidesToShow: 1,
		slidesToScroll: 1,
	})
	$(".recipes__arrows-left").click(function () {
		$(".recipes__slider").slick("slickPrev")
	})
	$(".recipes__arrows-right").click(function () {
		$(".recipes__slider").slick("slickNext")
	})
	$(".recipes__slider").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
		$(".recipes__splash-wrapper .recipes__splash").hide()
		$(".recipes__splash-wrapper .recipes__splash[data-index=" + nextSlide + "]").show()
	})
	if ($(window).width() < 1024) {
		var top = $(".recipes__image").height() + 15
		$(".recipes__splash").css("top", top)
	}

	$(".slideshow2__dots .dot").click(function () {
		$(".slideshow2__dots .dot").removeClass("active")
		var i = $(this).data("index")
		$(".slideshow2__dots .dot[data-index=" + i + "]").addClass("active")
		$(".slideshow2__wrapper").slick("slickGoTo", i)
	})
	$(".slideshow2__wrapper").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
		$(".slideshow2__dots .dot").removeClass("active")
		$(".slideshow2__dots .dot[data-index=" + nextSlide + "]").addClass("active")
		$(".slideshow2__wrapper").slick("slickGoTo", nextSlide)
	})

	$(".collection__filters-close").click(function () {
		$(".collection__filters").removeClass("collection__filters--visible")
		$("html").removeAttr("data-scroll-locked")
		$("body").removeClass("collection__filters-open")
	})

	$(".product-submit__text-below .icon-info").click(function () {
		$(this).parent().find(".product-submit__text-below-popup").show()
	})
	$(".product-submit__text-below-popup svg").click(function () {
		$(this).parent().hide()
	})

	if ($(window).width() < 768) {
		$(".how-to-use__item-heading").click(function () {
			$(this).parent().toggleClass("active")
			$(this).parent().find(".how-to-use__item-step").toggle()
			$(this).parent().find(".how-to-use__item-icons").toggle()
		})

		$(".recipes__accordion .recipes__content-title").click(function () {
			$(this).parent().toggleClass("active")
			$(this).parent().find(".recipes__content-text").slideToggle()
		})
	}

	$(".blog__post-search-dropdown .search-dropdown").change(function () {
		var url = $(this).val()
		if (url != "All Recipes") {
			window.location.href = url
		}
	})

	$(".mobile-mega__back").click(function () {
		$(".mobile-nav, .drawer__shop").show()
		$(".mobile-mega").hide()
	})

	$(".product__accordion__image-popup").magnificPopup({
		type: "inline",

		fixedContentPos: false,
		fixedBgPos: true,

		overflowY: "auto",

		closeBtnInside: true,
		preloader: false,

		midClick: true,
		removalDelay: 300,
		mainClass: "my-mfp-zoom-in",
	})

	$(".drawer__close-button").click(function () {
		$(".mobile-nav, .drawer__shop").show()
		$(".mobile-mega, .drawer__shop .tabcontent").hide()
		$(".drawer__shop .drawer__tab .tablinks").removeClass("active")
		$(".drawer__shop .drawer__tab .tablinks:first-child").addClass("active")
		$("#ShopByType.tabcontent").show()
	})

	$(".testimonials__marquee").simplyScroll({ pauseOnHover: true })

	var button = $(".btn")
	button.click(function () {
		$(this).addClass("clicked")
		setTimeout(function () {
			$(this).removeClass("clicked")
		}, 3000)
	})

	$(".blog__post-search-dropdown .search-wrapper").click(function () {
		$(this).toggleClass("open")
		$(this).find(".search-dropdown").slideToggle()
	})

	$(".blog__post-search-dropdown svg").click(function () {
		$(this).parent().find(".search-wrapper").toggleClass("open")
		$(this).parent().find(".search-dropdown").slideToggle()
	})

	$(".blog__post-search-input svg").click(function () {
		$(this).parent().submit()
	})

	$(".mosaic__item__content").click(function () {
		var link = $(this).data("link")
		window.location.href = link
	})

	document.addEventListener("rebuy:cart.change", (event) => {
		$.ajax({
			type: "GET",
			url: "/cart.js",
			cache: false,
			dataType: "json",
			success: function (cart) {
				$(".cart__bubble").text(cart.item_count)
			},
		})
	})

	$(".collection-promo__content").click(function () {
		var url = $(this).find("a").attr("href")
		if (typeof url === "undefined") {
		} else {
			window.location.href = url
		}
	})

	window.setInterval("iconAnimation()", 5000)
	window.setInterval("cardAnimation()", 3000)

	setTimeout(function () {
		$(".fantasy-hero").addClass("enable-animation")
	}, 1000)
	setTimeout(function () {
		$(".fantasy-hero__subheading").css("opacity", "0")
	}, 1000)
	setTimeout(function () {
		$(".fantasy-hero__content").hide()
		$(".fantasy-hero__arrow").show()
	}, 3000)

	$(".fantasy-hero__arrow").click(function () {
		var nextSection = $(this).parents(".shopify-section").next()
		$("html, body").animate(
			{
				scrollTop: nextSection.offset().top,
			},
			250
		)
	})

	if ($(window).width() > 1024) {
		init()

		var g_containerInViewport
		function init() {
			setStickyContainersSize()
			bindEvents()
		}

		function bindEvents() {
			window.addEventListener("wheel", wheelHandler)
		}

		function setStickyContainersSize() {
			document.querySelectorAll(".fantasy-featured-collection__wrapper").forEach(function (container) {
				const stikyContainerHeight = container.querySelector(".fantasy-featured-collection__inner").scrollWidth
				container.setAttribute("style", "height: " + stikyContainerHeight + "px")
			})
		}

		function isElementInViewport(el) {
			const rect = el.getBoundingClientRect()
			return rect.top <= 0 && rect.bottom > document.documentElement.clientHeight
		}

		function wheelHandler(evt) {
			const containerInViewPort = Array.from(document.querySelectorAll(".fantasy-featured-collection__wrapper")).filter(
				function (container) {
					return isElementInViewport(container)
				}
			)[0]

			if (!containerInViewPort) {
				return
			}

			var isPlaceHolderBelowTop = containerInViewPort.offsetTop < document.documentElement.scrollTop
			var isPlaceHolderBelowBottom =
				containerInViewPort.offsetTop + containerInViewPort.offsetHeight > document.documentElement.scrollTop
			let g_canScrollHorizontally = isPlaceHolderBelowTop && isPlaceHolderBelowBottom

			var offsetHeight = document.querySelectorAll(".fantasy-featured-collection__wrapper").offsetHeight
			if (g_canScrollHorizontally) {
				containerInViewPort.querySelector(".fantasy-featured-collection__inner").scrollLeft += evt.deltaY
			} else {
				$(".fantasy-featured-collection__wrapper").css("height", "1000px")
			}

			evt.preventDefault()
		}
	}

	$(".featured-collections2 .collection__products .grid").slick({
		dots: false,
		arrows: false,
		infinite: true,
		swipeToSlide: true,
		mobileFirst: true,
		centerMode: true,
		centerPadding: "40px",
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 767,
				settings: "unslick",
			},
		],
	})

	$(".featured-collections2__tabs .tabs__link").click(function () {
		$(".featured-collections2__tabs .tabs__link").removeClass("current")
		$(this).addClass("current")
		$(".featured-collections2__tab-content").removeClass("current")
		$(".featured-collections2__button .btn").removeClass("current")
		var i = $(this).data("tabs-link")
		$('.featured-collections2__tab-content[data-tab="' + i + '"]').addClass("current")
		$('.featured-collections2__button .btn[data-tab="' + i + '"]').addClass("current")

		if ($(window).width() < 768) {
			$(".featured-collections2 .collection__products .grid").slick("slickAdd")
		}
	})

	$(".featured-collections2__tab-content .tab-tags li").click(function () {
		$(this).parent().find("li").removeClass("current")
		$(this).addClass("current")
		var tag = $(this).data("tag")
		$(this).parents(".featured-collections2__tab-content").find(".collection__products-tag").removeClass("active")
		$(this)
			.parents(".featured-collections2__tab-content")
			.find("#collection__products-" + tag)
			.addClass("active")

		if ($(window).width() < 768) {
			$(".featured-collections2 .collection__products .grid").slick("slickAdd")
		}
	})

	$(".making__box ul.box-tab li.tab-link").click(function () {
		$(".making__content-tab").removeClass("current")
		$(".making__box ul.box-tab li.tab-link").removeClass("current")
		$(this).addClass("current")
		$(".making__box .box-tab-content").removeClass("current")
		var i = $(this).data("tab-link")
		$('.making__box .box-tab-content[data-tab="' + i + '"]').addClass("current")
		$('.making__content-tab[data-index="' + i + '"]').addClass("current")
	})

	$(".gamification__card-popup").click(function () {
		// $(this).find('.card-content').trigger('click');
		setTimeout(function () {
			$.magnificPopup.open({
				items: {
					src: $("#gamification__popup"),
				},
				type: "inline",

				fixedContentPos: false,
				fixedBgPos: true,

				overflowY: "auto",

				closeBtnInside: true,
				preloader: false,

				midClick: true,
				removalDelay: 300,
				mainClass: "my-mfp-zoom-in",

				callbacks: {
					beforeOpen: function () {
						$("html").addClass("disable-scroll")
					},
					beforeClose: function () {
						$("html").removeClass("disable-scroll")
					},
				},
			})
		}, 1500)
	})

	$(".gamification__card-popup .card-content").magnificPopup({
		type: "inline",

		fixedContentPos: false,
		fixedBgPos: true,

		overflowY: "auto",

		closeBtnInside: true,
		preloader: false,

		midClick: true,
		removalDelay: 300,
		mainClass: "my-mfp-zoom-in",

		callbacks: {
			beforeOpen: function () {
				$("html").addClass("disable-scroll")
			},
			beforeClose: function () {
				$("html").removeClass("disable-scroll")
			},
		},
	})

	$(".gamification__card").click(function () {
		$(".gamification__card").removeClass("open")
		//$('.gamification__card').removeClass('clicked');
		$(this).addClass("active")

		var card = $(this).data("card")
		var section = $(this).parents(".section-padding")
		if (card == "pink") {
			section.addClass("confetti-active")
			setTimeout(function () {
				section.removeClass("confetti-active")
			}, 5000)
		} else {
			$(this).addClass("clicked")
		}
	})

	flipCard()
	window.setInterval("flipCard()", 13500)
})

function removeClicked(i) {
	if ($(".gamification__grid .gamification__card:nth-child(" + i + ")").data("card") == "green") {
		$(".gamification__grid .gamification__card:nth-child(" + i + ")").removeClass("clicked")
	}
}

function flipCard() {
	$(".gamification__grid .gamification__card").each(function () {
		$(".gamification__grid .gamification__card:nth-child(1)").addClass("open")
		setTimeout(function () {
			$(".gamification__grid .gamification__card:nth-child(4)").addClass("open")
			$(".gamification__grid .gamification__card:nth-child(1)").removeClass("open")
			//removeClicked(1);
		}, 1500)
		setTimeout(function () {
			$(".gamification__grid .gamification__card:nth-child(3)").addClass("open")
			$(".gamification__grid .gamification__card:nth-child(4)").removeClass("open")
			//removeClicked(4);
		}, 3000)
		setTimeout(function () {
			$(".gamification__grid .gamification__card:nth-child(2)").addClass("open")
			$(".gamification__grid .gamification__card:nth-child(3)").removeClass("open")
			//removeClicked(3);
		}, 4500)
		setTimeout(function () {
			$(".gamification__grid .gamification__card:nth-child(5)").addClass("open")
			$(".gamification__grid .gamification__card:nth-child(2)").removeClass("open")
			//removeClicked(2);
		}, 6000)
		setTimeout(function () {
			$(".gamification__grid .gamification__card:nth-child(7)").addClass("open")
			$(".gamification__grid .gamification__card:nth-child(5)").removeClass("open")
			//removeClicked(5);
		}, 7500)
		setTimeout(function () {
			$(".gamification__grid .gamification__card:nth-child(6)").addClass("open")
			$(".gamification__grid .gamification__card:nth-child(7)").removeClass("open")
			//removeClicked(7);
		}, 9000)
		setTimeout(function () {
			$(".gamification__grid .gamification__card:nth-child(9)").addClass("open")
			$(".gamification__grid .gamification__card:nth-child(6)").removeClass("open")
			//removeClicked(6);
		}, 10500)
		setTimeout(function () {
			$(".gamification__grid .gamification__card:nth-child(8)").addClass("open")
			$(".gamification__grid .gamification__card:nth-child(9)").removeClass("open")
			//removeClicked(9);
		}, 12000)
		setTimeout(function () {
			$(".gamification__grid .gamification__card:nth-child(8)").removeClass("open")
			//removeClicked(8);
		}, 13500)
	})
}

function iconAnimation() {
	$(".fantasy-icons .fantasy-icon__item").each(function () {
		$(".fantasy-icons .fantasy-icon__item:nth-child(1)").addClass("active")
		setTimeout(function () {
			$(".fantasy-icons .fantasy-icon__item:nth-child(4)").addClass("active")
			$(".fantasy-icons .fantasy-icon__item:nth-child(1)").removeClass("active")
		}, 1000)
		setTimeout(function () {
			$(".fantasy-icons .fantasy-icon__item:nth-child(3)").addClass("active")
			$(".fantasy-icons .fantasy-icon__item:nth-child(4)").removeClass("active")
		}, 2000)
		setTimeout(function () {
			$(".fantasy-icons .fantasy-icon__item:nth-child(2)").addClass("active")
			$(".fantasy-icons .fantasy-icon__item:nth-child(3)").removeClass("active")
		}, 3000)
		setTimeout(function () {
			$(".fantasy-icons .fantasy-icon__item:nth-child(5)").addClass("active")
			$(".fantasy-icons .fantasy-icon__item:nth-child(2)").removeClass("active")
		}, 4000)
		setTimeout(function () {
			$(".fantasy-icons .fantasy-icon__item:nth-child(5)").removeClass("active")
		}, 5000)
	})
}
function cardAnimation() {
	setTimeout(function () {
		$(".fantasy-cards__images").attr("data-active", "1")
	}, 1000)
	setTimeout(function () {
		$(".fantasy-cards__images").attr("data-active", "2")
	}, 2000)
	setTimeout(function () {
		$(".fantasy-cards__images").attr("data-active", "3")
	}, 3000)
}

$(window).resize(function () {
	if ($(window).width() < 1024) {
		var top = $(".recipes__image").height() + 15
		$(".recipes__splash").css("top", top)
	}

	if ($(window).width() > 1024 && $(window).width() <= 1440) {
		var item = $(".pwi__slider .product-grid-item").width()
		if (item < 275) {
			var w = item * 3 + 195
			$(".pwi__influencer").css("width", $(window).width() - w)
		} else {
			$(".pwi__influencer").css("width", $(window).width() - 1020)
		}
	} else if ($(window).width() > 1440) {
		var item = $(".pwi__slider .product-grid-item").width()
		$(".pwi__influencer").css("width", item)
	} else {
		$(".pwi__influencer").css("width", "auto")
	}
})

$(document).mouseup(function (e) {
	var container = $(".collection__filters-open .collection__filters")
	if (!container.is(e.target) && container.has(e.target).length === 0) {
		$(".collection__filters-open .collection__filters-close").trigger("click")
	}

	var popup_info = $(".product-submit__text-below-popup")
	if (!popup_info.is(e.target) && popup_info.has(e.target).length === 0) {
		$(".product-submit__text-below-popup").hide()
	}
})

function openTab(evt, tabName) {
	// Declare all variables
	var i, tabcontent, tablinks

	// Get all elements with class="tabcontent" and hide them
	tabcontent = document.getElementsByClassName("tabcontent")
	for (i = 0; i < tabcontent.length; i++) {
		tabcontent[i].style.display = "none"
	}

	// Get all elements with class="tablinks" and remove the class "active"
	tablinks = document.getElementsByClassName("tablinks")
	for (i = 0; i < tablinks.length; i++) {
		tablinks[i].className = tablinks[i].className.replace(" active", "")
	}

	// Show the current tab, and add an "active" class to the button that opened the tab
	document.getElementById(tabName).style.display = "block"
	evt.currentTarget.className += " active"
}

function openMobileMega(id) {
	$(".mobile-nav, .drawer__shop").hide()
	$("#MobileMega--" + id).show()
	$("#nav-drawer").scrollTop(0)
}

// Fantasy collection page
function openRecipes(evt, recipeName) {
	var i, tabcontent, tablinks
	tabcontent = document.getElementsByClassName("fantasy-recipes__tabcontent")
	for (i = 0; i < tabcontent.length; i++) {
		tabcontent[i].style.display = "none"
	}
	tablinks = document.getElementsByClassName("tablinks")
	for (i = 0; i < tablinks.length; i++) {
		tablinks[i].className = tablinks[i].className.replace(" active", "")
	}
	document.getElementById(recipeName).style.display = "block"
	evt.currentTarget.className += " active"
	$(".fantasy-recipes__slider").slick("slickAdd")
	$(".fantasy-recipes__slider").slick("slickGoTo", 0)
	$(".fantasy-recipes__image").removeClass("active")
	$("#" + recipeName + "__image.fantasy-recipes__image").addClass("active")

	$(".fantasy-recipes__image").hide()
	$("#" + recipeName + "__image-1").show()
}
